import {useCallback, useEffect, useRef, useState} from "react";
import {doc, getDoc, updateDoc} from "firebase/firestore";
import {db} from "../../../Firebase";
import {kLibrettoUserCollectionName} from "../../../utils/CollectionConstants";

export const useAssistantDiscovery = (userId?: string | null) => {
    const [hasOpenedAssistant, setHasOpenedAssistant] = useState<boolean | null>(null);
    const openedLocallyRef = useRef(false);
    const normalizedUserId = String(userId || "").trim();

    useEffect(() => {
        let cancelled = false;
        openedLocallyRef.current = false;
        setHasOpenedAssistant(null);

        if (!normalizedUserId) return;

        void getDoc(doc(db, kLibrettoUserCollectionName, normalizedUserId))
            .then((snapshot) => {
                if (!cancelled && !openedLocallyRef.current) {
                    setHasOpenedAssistant(snapshot.data()?.hasOpenedEditorAssistant === true);
                }
            })
            .catch((error) => {
                console.warn("[Assistant] Could not load discovery state", error);
            });

        return () => {
            cancelled = true;
        };
    }, [normalizedUserId]);

    const markAssistantOpened = useCallback(() => {
        const wasAlreadyOpened = openedLocallyRef.current || hasOpenedAssistant === true;
        openedLocallyRef.current = true;
        setHasOpenedAssistant(true);

        if (!normalizedUserId || wasAlreadyOpened) return;

        void updateDoc(doc(db, kLibrettoUserCollectionName, normalizedUserId), {
            hasOpenedEditorAssistant: true,
        }).catch((error) => {
            console.warn("[Assistant] Could not save discovery state", error);
        });
    }, [hasOpenedAssistant, normalizedUserId]);

    return {
        showAssistantDiscovery: hasOpenedAssistant === false,
        markAssistantOpened,
    };
};

export default useAssistantDiscovery;
